<template>
  <el-tabs :tab-position="tabPosition" :stretch="true">
    <el-tab-pane label="系统通知">
      <div class="admin-msg-container">
        <AdminNoticeCell
          v-for="(notice, index) in adminNotice"
          :key="index"
          :notice="notice"
        />
        <p class="friend-apply" v-if="adminNotice.length == 0">暂无消息</p>
      </div>
    </el-tab-pane>
    <el-tab-pane>
      <el-badge
        slot="label"
        is-dot
        :hidden="initApplyUnread"
        class="left-menu-wrap"
      >
        传连通知
      </el-badge>
      <div class="hl-apply-container">
        <HandLianCell
          v-for="apply in handLianApply"
          :key="apply.id"
          :apply="apply"
        />
        <CopyTreeCell
          v-for="item in copyTreeApply"
          :key="item.id"
          :apply="item"
        />
        <p
          class="friend-apply"
          v-if="handLianApply.length == 0 && copyTreeApply.length == 0"
        >
          暂无消息
        </p>
      </div>
    </el-tab-pane>
    <el-tab-pane label="好友通知">
      <p class="friend-apply">请到手机端查找/添加好友</p>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { mapGetters } from "vuex";
import AdminNoticeCell from "./AdminNotice";
import HandLianCell from "./HandLianApply";
import CopyTreeCell from "./CopyTreeApply";
export default {
  name: "system_message",
  components: {
    AdminNoticeCell,
    HandLianCell,
    CopyTreeCell,
  },
  data() {
    return {
      tabPosition: "top",
    };
  },
  computed: {
    ...mapGetters(["adminNotice", "handLianApply", "copyTreeApply"]),
    initApplyUnread() {
      // console.log(this.handLianApply)
      // console.log(this.copyTreeApply)
      if (this.handLianApply.length == 0 && this.copyTreeApply.length == 0) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.friend-apply {
  width: 655px;
  height: 66px;
  line-height: 66px;
  text-align: center;
  background-color: #fff;
}
.admin-msg-container,
.hl-apply-container {
  margin-bottom: 10px;
}
</style>